module.exports = __webpack_public_path__ + "img/delete_outline_icon.865e4adb.svg";